<template>
    <div class="list-row">
		<div class="user flex ai_c" >
				<img :src=info.user.avatar :alt=info.user.username v-if="info.user && info.user.avatar"/>
				<img :alt=info.user.username src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAB5lBMVEUFa/4AAACuz/8Ibv6u0P+tz//w9v+51P/h7v6v0f+t0P+u0P+u0P9/tP+32P/F3f9BkP4Jb/+uz/8Vdv+u0P9Aj/6u0P+u0f+10/8pgv6u0P+TwP+v1P/i///n8f7C2v58sv5Gkv4jfv4ifv6rzv+t0P9Ol/6JuP+v0P+v0f/I2v+61//A2/+u0P8jfv+u0f8ziP+gyP9Gk/5cn/5fov+u0P+u0P+u0f+u0P+v0f+v0v+y1f/g7P9fov672P8RdP+tz/8pgf+kyf84iv1lpv5tqv+u0f+uz/+t0f+y0f+41v/////R5P/A2//C2/+62P+ny/+ZxP+Nvf+u0P+v0P+v0P+w0v+w0v+w0f+y0v+v0/+v0/+11v+y2P/i7//U5v/c6//R5P+Kuv9npf/H3//E3f8beP7F3f8McP+u0P8beP+Vwf9UnP6sz/+u0f/C2/+rzv+ly/+Zw/+Rvv59sv/K4f9Rmf5pqP83if4Mcf610/+vz//1+f9Nlf3E3P9ppv7f6//////0+P+lyv50rP7p8v/H3v6py/59sv5goP1Vmv2Ywv6BtP5ko/1bnf1Ql/1Nl/3R4/+Tvv2Dtv1Tmf3L4P/A2f/6/P6cxP6Ht/5wqv54r/3w9v/Z6P6uz/6iyP2bw/1vqf3GJSxAAAAAfHRSTlPMAMzMycr+BfrDt8admQ3z18fAvKOjcU/v0rOeKwP88uLX0dGyrZ+bi3sJ/sK5sqqppqGcm4d4bWlgNBP33MG/vK+pppqZg3dTKBkB6sjCua2gnJeTj1pHPDgvJCEW+vfz5eXe3dPQz8S9t6CdlGXx7Ovo5+Ld2djUxbpABVMc6wAABPZJREFUWMOtmGdfE0EQxs8NKUqMxIREJAkoFgxVpCgIqPTeQZq99153k5DQQkew92/qXFFv5y658NPn5WX437SduUXY9h+UBOKoHm4edB+8WVRiH6r0tvm3DmmrOkh4pdmHJ7cCqTl+gOjJbPdaU4RMetLlV/f2l2eWFrtcp0vLmrIV7I5WawqQoIzY3Z/pFDjVHzuaJmG8hpDqvQR0pgwIWrmaThHQ3cmkkGCLhMgUEsnZuEN005sEUuMGi1OHhGRy7jSDUaU/EWRCDOW2SzBQqZjjoaA+ZGw3VOSYYCxnNlDcDj3IBDC2ZwopaSdQ7FYtpAZiKTotpKhySEx+B4YE3ZB0YKSqRvDFgyFHIB8oFuOIXvOQUXiEcmqk2xC+Qw1xQAtlC1tTPfxNsxpSCT1Wr29ryssz6f+SCd6f/Qtph5Ol16dZuTk2CrLl5GYJWvVDt8gQJatHtTb7dlGVdu3TnsftiiuC4kgDtti/hyLt2a9TIfdviEfHkQwb1ciWgV2B0VMtQzogzbhFai1U0sx6QSxWsD5DJVlqkdlhQo7IkDEojQn5ITNml9aYpLWlWZmCfCkl5KZVgsAgOozyIcXydpkpWokztvxWigjlBYIYlSA7NGmVchoDLxStfp/9ydZiUnY1qa0UITUwAUx8bcE4usTUmrYULLClKPzAV7oB6iNCzmpqI/bHIuMVjkbibFHsF7734dxaAXKPkJ18n4LpO4b1+b0lzt7BT3zvwqhsA0g+IXe457lQ2QWm0Zupr6sLUOtczhgmpRcgdkJKuec5lM4xHa1PLbI5SnNwZk8ABBZ3Mff8HKXLepDwe8vqMqXnOOMmGHAAKSLExZ19aDKmq9DUPIOm40p5DHoWIND/3M7Mo/QDU4Sz8o19oDRPbX0IBjZA4DzfQJB5fcjnqTk2r4VUAAQa9hYK5xPT1+Im+4TCKZfDKSGEXxU2GmYJFaY2nNgqucQNqMTTiSHT+iWuwMsil37UB6xsrLKPqNn6CBkByAk8CbLoXKIS/4Buy8KzYAIg1fBVgw5gJEGJA9Mswh9AF4wAP0AchKQ70SiYZwk0j0ZBGSF2aShB35ehoRRKBAnt0QxZjwQ5DisUj8fpBLVB49EJ3zQ+CTIOcb1EgzqyolueSIZmk+5V9k4Jmiig2pBuMHhlZEOrKRAo8gG8tC/DTEVaKHiGjIrNhIwrEMduvM9Nj6I0EkYNH6GByxpHhpQ1KqW2V+3KNWmVW2Lxv4h4TNpnj7EjPhmiuNKoatmTVFY0tBHeZGwzvBGK/t7qqpcdJWRQ9ZEDWUkv/uPHeapWIEDVeqieAuY2FcTqht43KfnYRZPqksK4BdPsOPfhN572Z/tcogaSe+VGLyElVg4irjBSLoBefDGCnDeJ/vbB7vOh71h/PkQoHqH71FBP5ENDvJrP8qAdkntIyKDGOmkyAQMSgiDKx7258QFNQc/7gNGse1VpFy+xhTPGjAs9IsOPIIocEBF51WnEuAq1JVUdia5v1goCIXVbkiakR7RpTXYbbRXfUnc9kDCSbvFae9CX/ErbPkBA2wtP6iE6e0SE2WM1ulx3eKFKoLquTi6swJXCOiJqwJfKNd/qVa706YWFXVefXrx45XpXd52ZSBocS/UfDv6R/HSio6IW5AWCYAVHKvZygLSSlmpoDUMIlmN02HMkf+BuRWVVqw8lE0P+Xb8AUCCph/anQKAAAAAASUVORK5CYII=" v-else/>
				<span class="pointer">{{info.user.username}} </span>
			</div>
        <div class="list-content flex jc_b">
			<div class="pic" v-if="info.thumb&&info.thumb.length>0">
				<img :src=info.thumb>
			</div>
			
			<div class="right">
				<p ref="title" v-html="title" class="pointer title" @click="showDetail"></p>
				<p class="pointer content"
				    :class="{showAll:expand}" 
				    ref="content" 
				    v-html="content"
				    @click="showDetail" v-if="isShowDetail"></p>
				<span v-if="moreText" @click="triggerTextState">{{textState}}</span>
			</div>
        </div>
        <div class="list-footer flex jc_b ai_c">
			<div class="time flex ai_c">
				<img class="time-img" src="@/assets/image/forum/time-icon.png">
				<span class="time" style="color:rgba(96, 112, 125, 1);" >{{info.publishAt}} </span>
			</div>
			<div class="flex right">
				<span @click="triggerComment">
				    <i class="icon icon-comment"></i>
				    {{info.comments}} 条评论
				</span>
				<span @click="triggerCollection(info)" :class="{yellow:info.isCollection}">
				    <i class="icon icon-collection" :class="{yellow:info.isCollection}"></i>
				    {{info.collections}}
				</span>
				<span @click="triggerLike(info)" :class="{blue:info.isLike}">
				    <i class="icon icon-like" :class="{blue:info.isLike}"></i>
				    已赞 {{info.likes}}
				</span>
			</div>            
        </div>
        <div class="comment-area" v-show="commentOpen">
            <div class="comment-editor">
                <div ref="toolbar" class="editor-toolbar" v-show="false" />
                <div ref="editor" class="editor"></div>
            </div>
            <t-btn
                @click="confirmCommit"
                w="78px"
                h="36px"
				fs="12px"
				isText
                class="button bold">提交</t-btn>
        </div>
    </div>
</template>

<script>

import E from 'wangeditor'
import message from '@/mixins/message'

export default {
    name : "businessList",
    mixins: [message],
    props : {
        info : {
            type : Object,
            default : ()=>{
                return {}
            }
        },
        keyWord : {
            type : String,
            default : ""
        },
        forbidAuths : {
            type : Array,
            default : ()=>[]
        },
        listType : {
            type : Number,
            default : 0         //1主题 2评论 3收藏  
        },
		isShowDetail : {
		    type : Boolean,
		    default : true         //s是否显示详情
		}
    },
    data(){
        return {
            moreText : true,
            expand : true,          //显示文字全展示
            commentOpen : false     //是否展开评论框
        }
    },
    computed : {
        textState(){
            return this.expand ? "收起" : "展开"
        },
        title(){
            let title = this.info.title;
            if( title && this.keyWord ){
                title = title.replace(new RegExp(this.keyWord,'g'),"<span style='color:#0969fe'>"+this.keyWord+"</span>")
            }
            return title;
        },
        content(){
            let content = this.info.content;
            if( content && this.keyWord ){
                content = content.replace(new RegExp(this.keyWord,'g'),"<span style='color:#0969fe'>"+this.keyWord+"</span>")
            }
            return content;
        }
    },
    mounted(){
        let height = this.$refs.content && this.$refs.content.offsetHeight || 0
        if( height <= 48 ){
            this.moreText = false;
        }else{
            this.expand = false
        }

        const $e = this.$refs.editor;
        const $tool = this.$refs.toolbar;
        const editor = new E($tool,$e) // 工具栏和编辑器分开
        editor.config.showMenuTooltips = false;
        editor.config.height = 200;
        editor.config.placeholder = '请输入评论内容'
        editor.create()
        this.editor = editor;
    },
    methods : {
        judgeShow(info){
            return true
        },
        triggerLike(info){
            const {isLike,id} = info;
            const action = isLike ? "remove" : "add";
            if( isLike ){
                info.likes --;
            }else{
                info.likes ++;
            }
            info.isLike = !info.isLike
            this.$api.forum.like({
                id,action
            }).then(res=>{
                this.$emit("page")
            })
        },
        triggerCollection(info){
            const {isCollection,id} = info;
            const action = isCollection ? "remove" : "add";
            if( isCollection ){
                info.collections --;
            }else{
                info.collections ++;
            }
            info.isCollection = !info.isCollection
            this.$api.forum.collection({
                id,action
            }).then(res=>{
                console.log(this.listType)
                if( this.listType == 3 ){
                    this.$emit("refreshCollections")
                }else{
                    this.$emit("page")
                }                
            })
        },
        triggerComment(){
            if( this.forbidAuths.includes(4) ){
                this.error({
                    message: '该账号禁止发起评论'
                })
            }else{
                this.commentOpen = !this.commentOpen;
            }
        },
        triggerTextState(){
            this.expand = !this.expand;
        },
        confirmCommit(){
            const {id} = this.info;
            const content = this.editor.txt.html();
            this.$api.forum.comment({
                id,content,action:"add"
            }).then(res=>{
                this.editor.txt.clear()
                this.commentOpen = false;
                this.info.comments ++;
            })
        },
        showDetail(){
            this.$emit("showDetail")
        }
    }
}
</script>

<style lang="scss" scoped>

    .list-row {
		margin-bottom: 26px;
        .list-content {
            display: flex;
            // min-height: 80px;
            position: relative;
			.pic{
				margin-right: 16px;
				img {
				  width: 120px;
				  height: 80px; 
				}
			}
			.right{
				flex: 1;
				position: relative;
				.title{
					font-size: 18px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
					line-height: 25px;
					margin-bottom: 5px;
				}

				.content{
					width: 100%;
					text-overflow: ellipsis;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;					
					font-weight: 400;
					color: #333333;
					line-height: 1.8;
					word-break: break-all;
					text-align: justify;
					overflow: hidden;
					height: 48px;
					&.showAll {
					    height: auto;
					}
				}
				span{
					position: absolute;
					right: 0;
					bottom: 0;
					width: 56px;
					height: 28px;
					background: linear-gradient(90deg, rgba(255,255,255,0.9) 0%, #FFFFFF 100%);
					border-radius: 2px;
					cursor: pointer;
					text-align: center;
					line-height: 28px;
					color: #006AFF;
					font-size: 14px;
					display: inline-block;
				}
			}
        }

		.user{	
			margin-bottom: 10px;
				img{
					width: 28px;
					height: 28px;
					border-radius: 50%;
				}
				span{
					display: inline-block;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
					line-height: 20px;
					margin-left: 8px;
				}
			}
        .list-footer {
			margin-top: 12px;
			.time-img{
				width: 20px;
				height: 20px;
			}
			.right{
				span {
					display: flex;
					align-items: center;
					justify-content: center;
				    cursor: pointer;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #60707D;
					margin-left: 16px;
				    &.blue {
				        color: #0969fe
				    }
					&.yellow{
						color: #F4A93D;						
					}
				}
				.icon {
				    display: inline-block;
				    width: 20px;
				    height: 20px;
					margin-right: 2px;
				    &.icon-like {
				        background: url('../../../assets/image/forum/icon_dianzan_off.png') no-repeat;
				        background-size: 100%;
				        &.blue {
				            background: url('../../../assets/image/forum/icon_dianzan_on.png') no-repeat;
				            background-size: 100%;
				        }
				    }
				    &.icon-collection {
				        background: url('../../../assets/image/forum/icon_collect_off.png') no-repeat;
				        background-size: 100%;
				        &.yellow {
				            background: url('../../../assets/image/forum/icon_collect_on.png') no-repeat;
				            background-size: 100%;
				        }
				    }
				    &.icon-comment {
				        background: url('../../../assets/image/forum/icon_comment_off.png') no-repeat;
				        background-size: 100%;
				    }
				}
			}            
        }
        .comment-area {
            display: flex;
            align-items: flex-end;
			background: rgba(247,249,251,0.6);
			padding: 12px;
			border-radius: 8px;
			margin-top: 12px;
            .comment-editor {
                width: calc(100% - 78px);
                .editor {
                    border : none;
					font-size: 12px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #60707D;
					min-height: 17px;
					/deep/  .w-e-text-container{
						background: transparent;
						.w-e-text{
							padding: 0;
						}
						.placeholder{
							font-weight: 400;
							color: #9AAAB7!important;
							line-height:17px!important;
							font-size: 12px!important;
							top: 0;
							left: 0;
						}
						p{
							font-size: 12px !important;
							margin: 0;
							line-height:17px!important;
						}
					}
                }
            }
            .button {
				text-align: right;
				width: 78px!important;
            }
        }
    }

</style>